import Checkbox from './Checkbox';
import CheckboxItem from './CheckboxItem';
import AgreeItem from './AgreeItem';
Checkbox.CheckboxItem = CheckboxItem;
Checkbox.AgreeItem = AgreeItem;
export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/checkbox/index.js
// module id = null
// module chunks = 